import React, { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { pageAreaHandlers, pageAreaInitialState, pageAreaReducer } from '../reducers/PageAreaReducer';
import { FrameworkContext } from './FrameworkContent';
import { ParentContext } from './ParentContext';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';
import { usePageData } from './useHelpers/usePageData';

export const PageAreaContext = createContext();

const PageAreaProvider = (props) => {

  const { profileItems, pageItemsShown } = props

  const init_state = {}
  const [pageArea_state, pageData_dispatch] = useReducer(pageAreaReducer, pageAreaInitialState(init_state));

  const appUserAccess = useAppUserAccess()
  const { appUserSession } = appUserAccess ?? {}
  const { appUserSessionKey } = appUserSession ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { page_state, paps_state } = states ?? {}
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { viewKey } = paps_state ?? {}

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { desktopMode } = framework_state ?? {}

  const { layout: layout_page, desktopLayout: desktopLayout_page } = aps_page ?? {}

  const layout = desktopMode && desktopLayout_page ? desktopLayout_page : layout_page
  const { pageIcons: uiSelectedIcons, selectedItems: uiSelectedItems, fixFirstViewItem, gridTemplateRows } = layout ?? {}

  const prps = useMemo(() => {
    const _prps = {
      fixFirstViewItem,
      gridTemplateRows,
      isAppUserPage: appUserSessionKey === viewKey,
      pageIcons: uiSelectedIcons,
      pageItemsShown,
      pageViewItemKeys: pageItemsShown ? Object.keys(pageItemsShown) : [],
      profileItems,
      selectedItems: uiSelectedItems,
      pageItemsShown: props?.pageItemsShown,
      profileItems: props?.profileItems,
    }
    return _prps
  }, [_.keys(profileItems), _.keys(pageItemsShown)])

  const { pageData } = usePageData({ pageItems_shown: pageArea_state?.pageItemsShown })

  const pageArea_handlers = useMemo(
    () => pageAreaHandlers(pageData_dispatch),
    [pageData_dispatch]
  );

  useEffect(() => {
    pageArea_handlers.handleInit_pageArea(prps)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [props]);

  useEffect(() => {
    pageArea_handlers.handleAmmend_pageData(pageData)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [pageData]);

  return <PageAreaContext.Provider value={{ pageArea_state, pageArea_handlers }}>
    {props.children}
  </PageAreaContext.Provider>
};

export default PageAreaProvider